import {
  fetchUser as fetchUserFromApi,
  updateUser as updateUserFromApi
} from '@/api/proxy'
import { fetchUserPaymentCount, updateCurrency, fetchUserServices as fetchUserServicesFromUserApi } from '@/api/user'

const fetchUser = async ({ dispatch, commit }) => {
  let response = await fetchUserFromApi()
  let accountCurrency = ''
  let shouldForceUpdate = false
  if (!response.displayCurrency) { // If you have response but don't have currency check the account currency to update user
    if (response.account && response.account.balance && response.account.balance.currency) {
      accountCurrency = response.account.balance.currency
      shouldForceUpdate = true
    }
  }
  commit('SET_USER', response)
  if (shouldForceUpdate) {
    await dispatch('updateUser', {currency: accountCurrency})
  }
}
const fetchUserServices = async ({ commit }) => {
  let response = await fetchUserServicesFromUserApi()
  if (response.data && response.data.services) {
    commit('SET_USER_SERVICES', response)
  }
}

const loadUser = async ({ dispatch, state }) => {
  if (state.id === null) {
    await dispatch('fetchUser')
    await dispatch('fetchUserServices')
  }
}

const setCurrency = async ({ dispatch, state }) => {
  let response = await updateCurrency()
  return response
}

const getUserPaymentCount = async ({ commit }) => {
  let response = await fetchUserPaymentCount()
  commit('SET_PAYMENT_COUNT', response)
}
const updateUser = async ({ dispatch, state }, data) => {
  let user = {
    'id': state.id,
    'firstName': state.firstName,
    'lastName': state.lastName,
    'email': state.email,
    'currency': state.currency,
    'locale': state.locales[0],
    'timezone': state.timezone,
    'countryId': state.geolocation,
    'vatNumber': state.vatNumber
  }
  await updateUserFromApi({...user, ...data})
  await dispatch('fetchUser')
}

export default {
  fetchUser,
  getUserPaymentCount,
  loadUser,
  setCurrency,
  updateUser,
  fetchUserServices
}



// WEBPACK FOOTER //
// ./src/store/modules/user/actions.js